import Blockly from 'blockly'
import 'blockly/python'
import blocklyUtil from '../blocklyUtil'

let blockJson = {
  type: 'machine_ifzero_button',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_BUTTON}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/t3xqDPT/ifzerolite.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'field_dropdown',
      name: 'ACTION',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFZERO_BUTTON_V_PRESSED}', 'buttonPress'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_BUTTON_V_RELEASED}', 'buttonRelease']
      ]
    },
    {
      type: 'input_dummy'
    },
    {
      type: 'input_statement',
      name: 'STATEMENTS'
    }
  ],
  inputsInline: true,
  style: 'start_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_BUTTON_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_button'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_button'] = function (block) {
  let index = _.indexOf(ifzeroButtonBlocks, block.id)
  if (index < 0) {
    ifzeroButtonBlocks.push(block.id)
    index = _.indexOf(ifzeroButtonBlocks, block.id)
  }
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let dropdownAction = block.getFieldValue('ACTION')
  let statementsCallback = Blockly.Python.statementToCode(block, 'STATEMENTS')
  let functionName = `${dropdownAction}${index + 1}`
  let code = `def ${functionName}():
${blocklyUtil.getVariables(block)}${statementsCallback}\n
ifzero.${dropdownAction}(${functionName})\n\n`
  _.set(Blockly.Python.definitions_, `ifzeroButtonCode${index + 1}`, code)
  return ''
}

let ifzeroButtonBlocks = []
